export class SecuritySettingsModel {
    public static access_token = "access_token";
    public static remember_me = "remember_me";
    public static user_logged_in = "user_logged_in";
}